
  <nz-spin [nzSpinning]="loading" nzTip="{{'agentBuilder.message.detail.loading' | translateTA}}" >
    <div class="rounds-wrapper">
        <div *ngFor="let round of rounds" class="round-container">

        <div class="round-header">
                <div class="round-header-complement">
                    <h3>{{'agentBuilder.round' | translateTA}}: {{ round._id }}</h3>
                    <h5>{{round.createdAt | date:'yyyy-MM-dd HH:mm:ss.SSS'}}</h5>
                </div>

                <div class="labels">
                    <nz-tag *ngFor="let label of round.labels" nzColor="blue">
                    {{ label }}
                    </nz-tag>
                </div>
            </div>

            <nz-timeline class="conv-timeline">

            <!-- 3. Mensagens internas -->
            <nz-timeline-item *ngFor="let msg of round.messages">
                <div class="bubble" [ngClass]="getBubbleClass(msg)">

                <div class="header">
                    <nz-avatar nzSize="large" [nzSrc]="getAvatarAll(msg)"></nz-avatar>
                    <div class="meta">
                    <div class="role">{{ getRoleLabel(msg) }}</div>
                    </div>
                </div>

                <div class="bubble-content-wrapper">
                    <agent-builder-log-detail-expandable
                    [text]="msg.message"
                    [maxLines]="4">
                    </agent-builder-log-detail-expandable>
                </div>

                <!-- TOOL LOGS -->
                <ng-container *ngIf="msg.role === 'tool' && msg.toolOutput">
                    <nz-collapse nzAccordion class="tool-collapse">
                    <nz-collapse-panel nzHeader="{{'agentBuilder.toolDetails' | translateTA}}">
                        <pre>{{ msg.toolOutput | json }}</pre>
                    </nz-collapse-panel>
                    </nz-collapse>
                </ng-container>

                <div class="token-icon" *ngIf="msg.promptToken"
                    nz-tooltip
                    nzTooltipTitle=""
                    nz-popover
                    nzPopoverTitle="Tokens"
                    nzPopoverTrigger="hover"
                    nzPopoverOverlayClassName="token-popover-no-border"
                    [nzPopoverOverlayClickable]="false"
                    [nzPopoverContent]="tokenTpl">
                    <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                </div>

                <ng-template #tokenTpl>
                    <div class="token-info" *ngIf="msg.promptToken">
                    <div class="token-row">
                        <span class="label">Prompt:</span>
                        <span class="value">{{ msg.promptToken }}</span>
                    </div>

                    <div class="token-row">
                        <span class="label">Completion:</span>
                        <span class="value">{{ msg.completionTokens }}</span>
                    </div>

                    <div class="token-row total">
                        <span class="label">Total:</span>
                        <span class="value">{{ msg.totalTokens }}</span>
                    </div>

                    <div class="token-row id">
                        <span class="label">ID:</span>
                        <span class="value">{{ msg.completionId }}</span>
                    </div>
                    </div>
                </ng-template>
                

                </div>
            </nz-timeline-item>

            </nz-timeline>
        </div>
    </div>
  </nz-spin>
